var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"icon":"","small":""},on:{"click":_vm.reload}},'v-btn',_vm.$attrs,false),[_c('icon-with-tootip',{attrs:{"tooltip":"Reload"}},[_vm._v(" mdi-sync ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }